<style lang="scss">
@import '~scss/_variables';
$slider-transition-move: $grid-size * 13;
$slider-nav-width: $grid-size * 3;

.text-slider {
    @include media-smaller('md') {
        margin-left: -$mobile-pad;
        margin-right: -$mobile-pad;
    }

    .widget {
        display: flex;
        flex-flow: row nowrap;

        .slide-enter,
        .slide-leave-to {
            opacity: 0;
        }

        .slide-enter-active,
        .slide-leave-active {
            transition: all $transition-text-slider-item;
        }

        @include media-smaller('md') {
            display: block;
            margin-top: $grid-size;
        }
    }

        .container-content {
            position: relative;
            overflow: hidden;

            font-size: 24px;
            line-height: 1.6;
            text-align: left;

            background-color: $color-white;
            color: $color-text-2;

            @include media-larger('sm') {
                width: 100%;
                height: $grid-size * 6;
                padding: ($grid-size * 3) ($grid-size * 2) ($grid-size * 4) ($grid-size * 5);
                box-sizing: content-box;
            }

            @include media-smaller('lg') {
                padding: ($grid-size * 3) $grid-size ($grid-size * 3) ($grid-size * 4);
            }

            @include media-smaller('md') {
                padding: $grid-size $mobile-pad;
            }
        }

            .icon-container {
                display: flex;
                align-items: center;
                justify-content: center;

                font-size: 72px;
                color: $color-accent-1;

                @include media-larger('sm') {
                    transform: translate(-50%, -50%);
                    position: absolute;
                        top: $grid-size * 3;
                        left: $grid-size * 3;

                    .icon {
                        position: absolute;

                        &.slide-enter {
                            transform: translate(0%, ($slider-transition-move / 2));
                        }

                        &.slide-leave-to {
                            transform: translate(0%, -($slider-transition-move / 2));
                        }
                    }
                }

                @include media-smaller('lg') {
                    top: $grid-size * 2;
                    left: $grid-size * 2;
                    font-size: 48px;
                }

                @include media-smaller('md') {
                    position: relative;
                        top: 0;
                        left: 0;
                    justify-content: flex-start;

                    .icon {
                        &.slide-enter {
                            transform: translate(($slider-transition-move / 2), 0%);
                        }

                        &.slide-leave-to {
                            transform: translate(-($slider-transition-move / 2), 0%);
                        }

                        &.slide-leave-active {
                            position: absolute;
                        }
                    }
                }
            }

            .content {
                position: relative;

                h2 {
                    margin-top: $grid-size / 2;
                    font-family: $font-family-2;
                    font-size: 32px;
                    line-height: 1.4;
                }

                @include media-larger('sm') {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 100%;

                    .content-item {
                        position: absolute;
                        width: 100%;

                        &.slide-enter {
                            transform: translate(0%, $slider-transition-move);
                        }

                        &.slide-leave-to {
                            transform: translate(0%, -$slider-transition-move);
                        }
                    }
                }

                @include media-smaller('lg') {
                    .content-item {
                        font-size: 18px;
                    }
                }

                @include media-smaller('md') {
                    margin-top: $mobile-pad;

                    .content-item {
                        &.slide-enter {
                            transform: translate($slider-transition-move, 0%);
                        }

                        &.slide-leave-to {
                            transform: translate(-$slider-transition-move, 0%);
                        }

                        &.slide-leave-active {
                            position: absolute;
                        }
                    }
                }
            }

        .container-nav {
            display: flex;
            position: relative;

            &:before {
                content: '';
                position: absolute;
                    top: 0;
                    left: 0;

                background-color: $color-white;
            }

            nav {
                display: flex;
                flex-flow: column nowrap;
                align-items: center;
                justify-content: center;
                height: 100%;

                button {
                    display: block;
                    width: 40px;
                    height: 20px;
                    position: relative;
                    transition: height 0.2s ease-out;

                    &:before {
                        content: '';
                        width: 12px;
                        height: 12px;
                        position: absolute;
                            top: calc(50% - 6px);
                            left: calc(50% - 6px);
                        transform: scale(1);
                        border-radius: 50%;
                        background-color: $color-text-2;

                        transition:
                            background-color $transition-hover,
                            transform $transition-text-slider-button-hover;
                    }

                    &:hover,
                    &.is-enlarged {
                        &:before {
                            transform: scale(1.25);
                        }
                    }

                    &.is-active:before {
                        background-color: $color-accent-1;
                    }
                }
            }

            .next {
                position: absolute;
                    bottom: 0;

                svg {
                    font-size: 32px;
                    transition: transform $transition-text-slider-button-hover;
                }

                &:hover {
                    svg {
                        transform: translate(0, 3px);
                    }
                }
            }

            @include media-larger('sm') {
                flex: 0 0 auto;
                flex-flow: column nowrap;
                width: $slider-nav-width;

                &:before {
                    width: 100%;
                    height: calc(100% - #{$slider-nav-width});
                }

                .next {
                    width: 100%;
                    height: $slider-nav-width;
                    left: 0;
                }
            }

            @include media-smaller('lg') {
                width: $grid-size * 2;

                &:before {
                    height: calc(100% - #{$grid-size * 2});
                }

                .next {
                    height: $grid-size * 2;
                }
            }

            @include media-smaller('md') {
                width: 100%;
                height: $grid-size * 2;
                padding-left: $mobile-pad;

                &:before {
                    width: calc(100% - #{$grid-size * 2});
                    height: 100%;
                }

                nav {
                    flex-flow: row wrap;
                    margin: 0 #{-$mobile-pad / 2};

                    button {
                        width: (12px + $mobile-pad);
                        height: 100%;
                    }
                }

                .next {
                    width: $grid-size * 2;
                    height: $grid-size * 2;
                    right: 0;
                    transform: rotate(-90deg);

                    svg {
                        font-size: 25px;
                    }
                }
            }
        } // .container-nav

    .footer {
        display: flex;
        justify-content: space-between;
        box-sizing: content-box;
        position: relative;

        .banner,
        .social {
            padding: $grid-size;
            box-sizing: border-box;
            background: $color-background-1;
        }

        .banner {
            position: relative;

            font-size: 18px;
            line-height: 1.6;
            color: $color-white;

            p {
                margin-top: -0.5em;
                margin-bottom: 1.8em;
            }

            .wrapper-cta {
                width: 100%;
                padding: 0 $grid-size;
                position: absolute;
                    left: 0;
                    bottom: $grid-size;
                transform: translate(0, 100%);
            }

                button {
                    display: block;
                    width: 100%;
                    height: $grid-size * 2;
                }
        } // .banner

        .social {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;

            text-align: left;
            color: $color-accent-1;

            .social-content {
                p, ul {
                    margin-bottom: 0;
                }

                p {
                    font-family: $font-family-2;
                    font-weight: $font-weight-2-black;
                    font-size: 24px;
                    line-height: 1.3;
                }

                ul {
                    display: flex;
                    flex-flow: row wrap;
                    list-style-type: none;
                    margin: 0 -12px;
                    padding: 0;
                }

                    li {
                        width: 50%;
                    }

                        button {
                            padding: 0 12px;
                            font-size: 32px;
                            color: inherit;
                            transition: opacity $transition-hover;

                            &:hover {
                                opacity: 0.7;
                            }
                        }
            }
        }

        @include media-larger('sm') {
            margin-top: -$grid-size;
            margin-right: $grid-size * 2;

            .social {
                margin-left: $grid-size;
            }
        }

        @include media-larger('md') {
            margin-right: $slider-nav-width;
            padding: 0 ($grid-size * 3);
        }

        @include media-smaller('md') {
            flex-flow: column nowrap;
            margin-right: $grid-size * 2;
            text-align: left;

            .banner,
            .social {
                padding: $mobile-pad;
            }

            .social {
                justify-content: flex-start;
                padding-top: $grid-size;
                padding-bottom: 0;
            }

            .banner {
                order: 1;
                padding-bottom: $grid-size;

                p {
                    margin-bottom: $grid-size
                }

                .wrapper-cta {
                    padding: 0 $mobile-pad;
                }
            }
        }
    } // .footer
} // .text-slider
</style>

<template>
    <div class="text-slider">
        <div class="widget">
            <div class="container-content">
                <div class="icon-container">
                    <transition name="slide">
                        <fa class="icon" :icon="currentItem.icon" :key="currentItem.title"></fa>
                    </transition>
                </div>

                <div class="content">
                    <transition name="slide">
                        <div class="content-item" :key="currentItem.title">
                            <span class="subtitle">{{ currentItem.content.type }}</span>
                            <h2>{{ currentItem.title }}</h2>
                            <p v-html="currentItem.content.text"></p>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="container-nav">
                <button
                    class="next"
                    @click="selectNextItem"
                    @mouseover="highlightNextItem = true"
                    @mouseleave="highlightNextItem = false"
                >
                    <fa :icon="['fas', 'arrow-down']"></fa>
                </button>

                <nav>
                    <button
                        v-for="(slide, index) in slides"
                        :key="index"
                        @click="currentItemIndex = index"
                        tabindex="-1"
                        :class="{
                            'is-active': (currentItemIndex === index),
                            'is-enlarged': (nextItemIndex === index && highlightNextItem)
                        }"
                    ></button>
                </nav>
            </div><!-- .container-nav -->
        </div>

        <div class="footer">
            <div class="banner">
                <p>Get more interesting facts and advices about decreasing your emissions!</p>
                <div class="wrapper-cta">
                    <router-link tag="button" to="/form" class="rect inverted arrow">
                        <span>Calculate new trip</span> <fa :icon="['fas', 'arrow-square-right']"></fa>
                    </router-link>
                </div>
            </div>

            <div class="social">
                <div class="social-content">
                    <p>Share</p>
                    <ul>
                        <li v-for="name in shareButtons" :key="name">
                            <button @click="shareButtonClicked(name)"><fa :icon="['fab', name]"></fa></button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import extend from 'extend';
import strip_tags from 'striptags';
import * as social from '@/modules/social';

export default {
    props: {
        items: {
            type: Array
        }
    },
    data () {
        return {
            currentItemIndex: 0,
            highlightNextItem: false,
            shareButtons: ['facebook', 'twitter']
        };
    },
    computed: {
        slides () {
            return this.items.reduce(function (memo, category) {
                var entries = category.entries,
                    index = Math.floor(Math.random() * entries.length);

                memo.push(extend({}, category, {
                    content: entries[index]
                }));

                return memo;
            }, []);
        },
        currentItem () {
            var item = this.slides[this.currentItemIndex];
            return item || null;
        },
        nextItemIndex () {
            var index = this.currentItemIndex + 1;
            if (index >= this.slides.length) {
                index = 0;
            }

            return index;
        }
    },
    methods: {
        selectNextItem () {
            if (this.slides[this.nextItemIndex]) {
                this.currentItemIndex = this.nextItemIndex;
            }
        },
        shareButtonClicked (name) {
            if (name === 'facebook') {
                social.facebookPopup({
                    url: window.location.href
                });
            } else if (name === 'twitter') {
                social.twitterPopup({
                    text: window.location.hostname + ': ' + strip_tags(this.currentItem.content.text)
                });
            }
        }
    }
};
</script>
